import { http } from '@/utils/http';
import qs from 'qs';

const baseUrl = 'vote/2020project/2020ninedream/controller.php?enews=';

export const getTypes = () => {
  return http.get(`${baseUrl}getTypes`);
};

export const rank = (type: number, page: number) => {
  return http.get(`${baseUrl}rank&type=` + type + '&page=' + page);
};
// 用户个人上传列表
export const voteListUser = () => {
  return http.get(`${baseUrl}vote-list-user`);
};
// 个人列表删除接口
export const deleteUser = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${baseUrl}delete`, qsData);
};
// 获取区县列表
export const getAreas = () => {
  return http.get(`${baseUrl}getAreas`);
};

// 搜索学校列表
export const getSchools = (search: any) => {
  return http.get(`${baseUrl}getSchools&search=` + search);
};
// 获取详情页面
export const detail = (id: any, type: any) => {
  return http.get(`${baseUrl}detail&id=` + id + '&type=' + type);
};
// 获取获奖列表
export const WinningList = (page: number) => {
  return http.get(`${baseUrl}WinningList&page=` + page);
};
